import { defineStore } from 'pinia'

export const useSettingsStore = defineStore('settings', {
    state: () => ({
        showToolsParams: false,
        showToolsResult: false,
    }),

    actions: {
        setShowToolsParams(value) {
            this.showToolsParams = value
            try {
                localStorage.setItem('settings-show-tools-params', JSON.stringify(value))
            } catch (e) {
                console.warn('Unable to save settings', e)
            }
        },

        setShowToolsResult(value) {
            this.showToolsResult = value
            try {
                localStorage.setItem('settings-show-tools-result', JSON.stringify(value))
            } catch (e) {
                console.warn('Unable to save settings', e)
            }
        },

        loadSettings() {
            try {
                const saved = localStorage.getItem('settings-show-tools-params')
                if (saved !== null) {
                    this.showToolsParams = JSON.parse(saved)
                }
            } catch (e) {
                console.warn('Unable to read settings', e)
            }
            try {
                const saved = localStorage.getItem('settings-show-tools-result')
                if (saved !== null) {
                    this.showToolsResult = JSON.parse(saved)
                }
            } catch (e) {
                console.warn('Unable to read settings', e)
            }
        },
    }
})
